import { AfterContentInit, Directive, ElementRef, HostBinding, Inject, Input } from '@angular/core'
import { IS_PLATFORM_SERVER } from '@upkey-platform/core/core-data-access'

@Directive({
  selector: '[uLazyLoadImage]'
})
export class LazyLoadImageDirective implements AfterContentInit {
  @HostBinding('attr.src') srcAttr: string | null = null
  @HostBinding('attr.srcset') srcSetAttr: string | null = null
  @Input() src: string
  @Input() srcset: string
  constructor(private el: ElementRef, @Inject(IS_PLATFORM_SERVER) private isServer: boolean) {
    this.el.nativeElement.setAttribute('loading', 'lazy')
  }

  ngAfterContentInit() {
    this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage()
  }
  private canLazyLoad() {
    if (!this.isServer) {
      return window && 'IntersectionObserver' in window
    }
    return null
  }

  private lazyLoadImage() {
    const observerObs = new IntersectionObserver((obs) => {
      obs.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.loadImage()
          observerObs.unobserve(this.el.nativeElement)
        }
      })
    })
    observerObs.observe(this.el.nativeElement)
  }

  private loadImage() {
    this.srcAttr = this.src
    this.srcSetAttr = this.srcset
  }
}
